import { useState , useEffect } from 'react';
import VoteCard from './voteCard';
import Timer from '../features/timer';
let votes = require('../seeders/seedVotes.json');


function getCardInfo(){
    const PORT=3000
    const MONGO_URI="mongodb://localhost:27017/votes"
 }


 function VoteConfModal(props) {
    const [ finalVote , setFinalVote ] = useState(props.option)
    const [ voteConfAction , setVoteConfAction ] = useState('')
    const [ hideModal , setHideModal ] = useState(true)
    let local_vote_pair = JSON.parse(localStorage.getItem('TH_vote_pair'))
    let optionClass =`vote-confirmation-wrap ${voteConfAction}`
    const now = new Date()
console.log("props.open",props.open)
    if(props.open){setHideModal(false)}

     class MSG_OBJ {
        constructor(props){
            // super(props)
            this.state = { 
                user: JSON.parse(localStorage.getItem('cur_user')),
                timestamp: Date.now(),
                body:'',  
                sent: false 
             } 
             handleChange = handleChange.bind(this)
            //  confirmVote = confirmVote.bind(this)  
            }
        }

    function confirmVote(e){
        e.preventDefault()
        // mod = document.getElementById('')
        console.log("Confirm Vote Option:",JSON.parse(localStorage.getItem('TH_vote_pair')))
        if(JSON.parse(localStorage.getItem('TH_vote_pair'))){localStorage.setItem('TH_vote_submit',true)}
        let val = JSON.parse(localStorage.getItem('TH_vote_submit'))
        console.log("vote submit",val)
        // window.location.href = `/meeting`
    }
    function closeModal(e){
        e.preventDefault()
        // mod = document.getElementById('')
        console.log("Close Modal")
        // setVoteConfAction('slide-down')
        localStorage.setItem('TH_vote_pair',false)
        localStorage.setItem('TH_vote_submit',false)
        console.log("[closeModal] vote_submit: ",JSON.parse(localStorage.getItem('TH_vote_submit')))
        // setHideModal(true)        
    }
    function handleChange(e){
        // setFinalVote(false)
        let msg_obj
        e.preventDefault()
        // if (newMSG){
        //     let msg_obj = new MSG_OBJ
        // }else{ msg_obj = e.target.value}
        
    }
    
    function voteContent(){
            return (
                <div className={optionClass}>
                    <p>
                        Are you sure you'd like to select: 
                        <br/>
                       <span className="vote_lit_option">{props.option}</span>
                    </p>
                    {/* <input type="submit" key="vt-cnf-btn"></input> */}
                </div>
            )  
    }
    useEffect(()=>{
        // vote_pair = JSON.parse(localStorage.getItem('vote_pair'))
       setHideModal(JSON.parse(localStorage.getItem('TH_vote_submit')))
        // if(!vote_pair){setConfirmToggle(false)}
        // else if((!vote_pair ) && (local_togg)){setConfirmToggle(true)}
        
        // if(!vote_pair){setConfirmToggle(false)}
        // else if((!vote_pair ) && (local_togg)){setConfirmToggle(true)}
    },[])


     return ( 
         <>
         {/* {(JSON.parse(localStorage.getItem('vote_sumbit'))) && ( */}
         {(!hideModal && localStorage.getItem('vote_submit'))&& (
         <div className="vote-confirmation-container  center">   
                <h1 className="color-grad-blue-text"></h1>
                <form onSubmit={(e)=>{confirmVote(e)}} key="chat-" >
                    {/* <div> */}
                    &nbsp;
                    {voteContent()}
                    {/* </div> */}
                    <hr/>
                    <div className='vote-modal-bottom'>
                        <div onClick={(e)=>{closeModal(e)}} type="submit" name ='cancel' className='vote-submit-btn blink btn-spc cancel' key="vt-cncl-btn">cancel</div>
                        <div onClick={(e)=>{confirmVote(e)}} type="submit" name ='submit' className='vote-submit-btn blink btn-spc' key="vt-cnf-btn">confirm</div>
                    </div>
                </form>
            
            </div>
            )} 
            </>
        )

}
export default VoteConfModal; 